import styled from '../../theme/styled-with-theme';

import { VariationProps } from '.';

export const StyledVariation = styled('div')<VariationProps>`
  display: ${({ isActive }) => (isActive ? 'block' : 'none')};
`;
